export default __webpack_public_path__ + "818df221f4d1230df65638ee1b245b14.png";